import { Permissions } from '@marketing-milk/interfaces'
import { NestAPI, sessionContext } from '@marketing-milk/frontend'
import { useContext, useEffect, useState } from 'react'

export interface SlackUser {
  id: string
  displayName: string
  pfp: string
}

export const useSlackUsers = () => {
  const [users, setUsers] = useState<SlackUser[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  // The Slack endpoints are AE-only. Client-review-only sessions
  // (`AccessPacketReview`) mount CommentThread on the packet deck, so without
  // this check every client opening a packet fires a request that 401s.
  const { user } = useContext(sessionContext)
  const hasBuilderAccess = !!user && user.permissions.includes(Permissions.AccessAdBuilderApp)

  useEffect(() => {
    if (!hasBuilderAccess) return

    const fetchSlackUsers = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const response = await NestAPI.get('/slack/users')

        setUsers(response.data)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'))
        console.error('Error fetching Slack users:', err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchSlackUsers()
  }, [hasBuilderAccess])

  return { users, isLoading, error }
}
